/* eslint-disable no-template-curly-in-string */
import * as Yup from 'yup';
import { TransportType } from '../../../services/models/vaccination';
import { removeTime } from '../../../utils/functions/date';

Yup.setLocale({
  mixed: {
    default: 'Inválido',
    required: 'Obrigatório',
    oneOf: 'Deve ser um dos seguintes valores: ${values}',
    notOneOf: 'Não pode ser um dos seguintes valores: ${values}',
  },
  string: {
    length: 'Deve ter exatamente ${length} caracteres',
    min: 'Deve ter pelo menos ${min} caracteres',
    max: 'Deve ter no máximo ${max} caracteres',
    email: 'E-mail inválido',
    url: 'Deve ter um formato de URL válida',
    trim: 'Não deve conter espaços no início ou no fim.',
    lowercase: 'Deve estar em maiúsculo',
    uppercase: 'Deve estar em minúsculo',
  },
  number: {
    min: 'Deve ser no mínimo ${min}',
    max: 'Deve ser no máximo ${max}',
    lessThan: 'Deve ser menor que ${less}',
    moreThan: 'Deve ser maior que ${more}',
    // notEqual: 'Não pode ser igual à ${notEqual}',
    positive: 'Deve ser um número posítivo',
    negative: 'Deve ser um número negativo',
    integer: 'Deve ser um número inteiro',
  },
  date: {
    min: 'Deve ser maior que a data ${min}',
    max: 'Deve ser menor que a data ${max}',
  },
  array: {
    min: 'Deve ter no mínimo ${min} itens',
    max: 'Deve ter no máximo ${max} itens',
  },
});

export const SecondStepSchema = Yup.object({
  date: Yup.date()
    .typeError('Data inválida')
    .min(removeTime(new Date()))
    .required(),
  hour: Yup.date().typeError('Hora inválida').required(),
  // check: Yup.boolean().oneOf([true], 'Termo obrigatório').required(),
});

export const ThirdStepSchema = Yup.object({
  transportType: Yup.mixed<TransportType>()
    .oneOf([
      TransportType.AppOrTaxi,
      TransportType.OwnVehicle,
      TransportType.PublicTransportation,
    ])
    .required(),
  vehicleId: Yup.string().when('transportType', {
    is: TransportType.OwnVehicle,
    then: Yup.string()
      .min(7, 'A placa deve conter 7 caracteres')
      .matches(/([A-Z]{3}\d{4}|[A-Z]{3}\d{1}[A-Z]{1}\d{2})/i, 'Placa inválida')
      .required(),
    otherwise: Yup.string(),
  }),
});

export type VaccineValues = Yup.InferType<typeof SecondStepSchema> &
  Yup.InferType<typeof ThirdStepSchema>;
